import { render, staticRenderFns } from "./_layout.vue?vue&type=template&id=281d1d3c&"
import script from "./_layout.vue?vue&type=script&lang=js&"
export * from "./_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports